// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"6b65bd04","187":"1910a293","290":"aac6100e","436":"a2a41379","544":"5b89a1d0","639":"9dd8731a","694":"2e130b63","767":"32808477"}[chunkId] + ".chunk.js";
};